<script lang="ts">
  import CollapseSection from '$lib/components/common/CollapseSection.svelte';
  import type { FPost, WithCreatorData } from 'garden-common';

  export let post: Partial<FPost<string>> & Partial<WithCreatorData>;
</script>

<div class="flex flex-col gap-6 overflow-x-hidden">
  <div class="flex flex-col gap-2">
    <CollapseSection contentOpen>
      <span slot="title" class="text-blueish-grey-900 font-bold"> Artist information </span>

      <div class="flex flex-col gap-2 pt-6">
        <div class="flex flex-col gap-2">
          <span class="text-blueish-grey-600 text-sm font-medium"> Artist's name </span>
          <span class="text-garden-grey-800 text-sm font-medium">
            {post.artistsDetails.artistName}
          </span>
        </div>
        <div class="flex flex-col gap-2">
          <span class="text-blueish-grey-600 text-sm font-medium"> Biography </span>
          <span class="text-garden-grey-800 text-sm font-medium">
            {post.artistsDetails.artistBio}
          </span>
        </div>
      </div>
    </CollapseSection>
    {#if post.artistsDetails.artistWebsite || post.artistsDetails.artistSocialMedia}
      <CollapseSection>
        <span slot="title" class="text-blueish-grey-900 font-bold"> Online Presence </span>

        <div class="flex flex-col gap-2 pt-6">
          {#if post.artistsDetails.artistWebsite}
            <div class="flex flex-col gap-2">
              <span class="text-blueish-grey-600 text-sm font-medium"> Portfolio </span>
              <span class="text-garden-grey-800 text-sm font-medium">
                <a class="underline" href="https://{post.artistsDetails.artistWebsite}"
                  >{post.artistsDetails.artistWebsite}</a
                >
              </span>
            </div>
          {/if}

          {#if post.artistsDetails.artistSocialMedia}
            <div class="flex flex-col gap-2">
              <span class="text-blueish-grey-600 text-sm font-medium"> Twitter </span>
              <span class="text-garden-grey-800 text-sm font-medium">
                <a class="underline" href="https://{post.artistsDetails.artistSocialMedia}"
                  >{post.artistsDetails.artistSocialMedia}</a
                >
              </span>
            </div>
          {/if}
        </div>
      </CollapseSection>
    {/if}

    <div class="pt-4">
      <h3 class="text-blueish-grey-700 font-bold">
        Post managed by @{post.creatorData.userName}
      </h3>
    </div>
  </div>
</div>
